import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsHalfWayMocks: MicroMoments = {
  id: 'half-way-to-platinum-medallion-status',
  actionId: 'half-way-to-platinum-medallion-status-link',
  title: 'Rocky, you’re half-way to earning Platinum Medallion® Status!',
  description:
    'As a Platinum Medallion you’ll unlock more exclusive benefits like your favorite pick of our Choice Benefit offerings and even higher priority for Unlimited Complimentary Upgrades.  Medallion benefit terms apply.',
  action: {
    label: 'Explore Platinum Medallion Benefits',
    url: '/us/en/skymiles/medallion-program/platinum-medallion-status'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/half-way.svg',
    alt: 'Half Way Travel Logo image'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
